import { noop } from "lodash";
import PropTypes from "prop-types";
import styled from "styled-components";
import ty from "typy";

import { DropDown } from "@flexisaf/flexibull2/build/dropdown";
import { IconThreeDot } from "@/components/icons";
import ActionItem from "./ActionItem";
import { StyledActionsWrapper } from "./tableStyles";

const DropdownIconWrapper = styled.span`
    margin-right: 0.5em;
    display: inline-flex;
    align-items: center;
    svg {
        width: 1em;
        height: 1em;
    }
`;

const VerticalThreeDots = styled.span`
    display: inline-flex;
    align-items: center;
    justify-content: center;
    svg {
        width: 1.25em;
        height: 1.25em;
        transform: rotate(90deg);
    }
`;

export default function Actions(props) {
    const { actions, item, asDropdown } = props;

    const visibleActions = actions.filter((action) => {
        const isHidden =
            ty(action.hidden).isFunction ? action.hidden(item) : action.hidden;
        return !isHidden;
    });

    if (asDropdown) {
        if (visibleActions.length === 0) return null;
        return (
            <DropDown
                label={
                    <VerticalThreeDots>
                        <IconThreeDot width="1.25em" height="1.25em" />
                    </VerticalThreeDots>
                }
                trigger="click"
                menuAlign="right bottom"
            >
                {visibleActions.map((action) => {
                    const disabled =
                        ty(action.disabled).isFunction
                            ? action.disabled(item)
                            : action.disabled;
                    const isLoading =
                        ty(action.isLoading).isFunction
                            ? action.isLoading(item)
                            : action.isLoading;
                    const handleClick = (evt) => {
                        evt.stopPropagation();
                        if (disabled || isLoading) return;
                        if (ty(action.fn).isFunction) action.fn(item, evt);
                    };
                    const handleKeyDown = (evt) => {
                        if (evt.key === "Enter" || evt.key === " ") {
                            evt.preventDefault();
                            handleClick(evt);
                        }
                    };
                    return (
                        <li
                            key={action.label}
                            role="menuitem"
                            tabIndex={0}
                            onClick={handleClick}
                            onKeyDown={handleKeyDown}
                            title={action.title || action.label}
                            style={{
                                display: "flex",
                                alignItems: "center",
                                cursor: disabled || isLoading ? "not-allowed" : "pointer",
                                opacity: disabled || isLoading ? 0.6 : 1,
                            }}
                            data-disabled={disabled || isLoading}
                        >
                            <DropdownIconWrapper>{action.icon}</DropdownIconWrapper>
                            {action.label}
                        </li>
                    );
                })}
            </DropDown>
        );
    }

    return (
        <StyledActionsWrapper>
            {actions.map((action) => {
                const isHidden =
                    ty(action.hidden).isFunction ? action.hidden(item) : action.hidden;
                if (isHidden) return null;

                return (
                    <ActionItem
                        key={action.label}
                        icon={action.icon}
                        title={action.title}
                        fn={(evt) =>
                            ty(action.fn).isFunction ? action.fn(item, evt) : noop
                        }
                        disabled={
                            ty(action.disabled).isFunction
                                ? action.disabled(item)
                                : action.disabled
                        }
                        isLoading={
                            ty(action.isLoading).isFunction
                                ? action.isLoading(item)
                                : action.isLoading
                        }
                    />
                );
            })}
        </StyledActionsWrapper>
    );
}

Actions.propTypes = {
    actions: PropTypes.arrayOf(PropTypes.object),
    item: PropTypes.object,
    asDropdown: PropTypes.bool,
};
